if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountDownTimer extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          days: this.querySelector('[data-tick="days"]'),
          hours: this.querySelector('[data-tick="hours"]'),
          minutes: this.querySelector('[data-tick="minutes"]'),
          seconds: this.querySelector('[data-tick="seconds"]'),
        };

        this.datetime = null;

        if (this.querySelector('time')) {
          const date = this.querySelector('time').getAttribute('datetime');
          this.datetime = date ? new Date(date).getTime() : null;
        }

        if (this.datetime) {
          this.updateClock();
          this.tick = setInterval(this.updateClock.bind(this), 1000);
        }
      }

      updateClock() {
        const now = new Date().getTime();
        const distance = this.datetime - now;

        if (distance > 0) {
          this.elements.days.innerText = Math.floor(distance / (1000 * 60 * 60 * 24))
            .toString()
            .padStart(2, '0');
          this.elements.hours.innerText = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            .toString()
            .padStart(2, '0');
          this.elements.minutes.innerText = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            .toString()
            .padStart(2, '0');
          this.elements.seconds.innerText = Math.floor((distance % (1000 * 60)) / 1000)
            .toString()
            .padStart(2, '0');
        } else {
          clearInterval(this.tick);
        }
      }
    }
  );
}
